// Subtle, automatic palette shifts based on time of day, plus a slightly more energetic theme
// during configured exam windows. These are small CSS-variable overrides (see index.css), not a
// full redesign — the goal is a gentle ambient cue, not a jarring color swap.

// Update these per semester. Format: 'YYYY-MM-DD' (inclusive on both ends).
const EXAM_WINDOWS = [
  { start: '2026-04-20', end: '2026-04-30' },
  { start: '2026-11-20', end: '2026-11-30' },
];

const formatLocalYmd = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const isWithinExamWindow = (date) => {
  const ymd = formatLocalYmd(date);
  return EXAM_WINDOWS.some((window) => ymd >= window.start && ymd <= window.end);
};

export const THEME_CLASS_NAMES = ['theme-morning', 'theme-evening', 'theme-exam-week'];

export const getThemeKey = (date = new Date()) => {
  if (isWithinExamWindow(date)) {
    return 'theme-exam-week';
  }
  const hour = date.getHours();
  return hour >= 5 && hour < 17 ? 'theme-morning' : 'theme-evening';
};
